import { Options, Vue } from 'vue-class-component';

import List from '@/pages/config/company-type/list/list.vue';

@Options({
  name: 'company-type',
  components: {
    'page-list': List,
  },
})
export default class CompanyType extends Vue {
  public isIndexOnly() {
    return /^[/]?company-type[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
